import { LineChart, Loader2 } from "lucide-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useFinanceModuleFlag } from "../hooks/useFinanceModuleFlag";
import { dictionary } from "../utils/dictionary";

type FinanceAccessRouteProps = {
  children: ReactNode;
};

const FinanceAccessRoute = ({ children }: FinanceAccessRouteProps) => {
  const { enabled, loading } = useFinanceModuleFlag();
  const { language } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f5f6fa] text-sm font-medium text-gray-500">
        <Loader2 className="mr-2 h-4 w-4 animate-spin text-[#2b5ce6]" />
        Cargando Fluxi Métricas...
      </div>
    );
  }

  // Sin redirect silencioso: mandar a /home sin explicación parece un bug.
  // Se muestra el motivo y una salida clara hacia el inicio.
  if (!enabled) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#f5f6fa] px-6 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-400">
          <LineChart className="h-5 w-5" />
        </span>
        <p className="max-w-sm text-sm font-medium text-gray-600">
          {dictionary["metrics-not-enabled"][language]}
        </p>
        <Link
          to="/home"
          className="rounded-full border border-[#2b5ce6] bg-white px-4 py-2 text-sm font-medium text-[#2b5ce6] transition hover:bg-[#eef2fd]"
        >
          {dictionary["back-to-home"][language]}
        </Link>
      </div>
    );
  }

  return <>{children}</>;
};

export default FinanceAccessRoute;
